const modalId = '#deleteModal';

$(() => {
    $(document).on('click', `[data-bs-target="${modalId}"]`, function () {
        $(modalId)
            .find('form')
            .attr('action', $(this).data('action'));
    });
});